module.exports = __webpack_public_path__ + "static/media/do3.26350dbf.png";